import { render, staticRenderFns } from "./transection.vue?vue&type=template&id=7d5ba514&"
import script from "./transection.vue?vue&type=script&lang=js&"
export * from "./transection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports